import type { FunctionComponent, InputHTMLAttributes } from 'react';

import { Icon } from '../../icons/icon';
import { Icons } from '../../icons/iconNames';
import type { InputProps } from '../../inputs/baseInput/BaseInput';

import styles from './MiniChatInput.module.css';

export interface MiniChatInputProps
  extends InputHTMLAttributes<HTMLInputElement>,
    Pick<InputProps, 'errorMessage' | 'supportingText' | 'inputRef'> {
  isGameChatUnavailable?: boolean;
  handleMouseDownEvent?: () => void;
}

export const MiniChatInput: FunctionComponent<MiniChatInputProps> = ({
  disabled,
  errorMessage,
  inputRef,
  supportingText,
  handleMouseDownEvent,
  isGameChatUnavailable,
  value,
  ...rest
}) => {
  return (
    <div className={styles.miniChatInput__container}>
      <div className={styles.miniChatInput}>
        <input
          ref={inputRef}
          value={value}
          type="text"
          className={styles.miniChatInput__input}
          disabled={disabled}
          {...rest}
        />
        {disabled ? null : (
          <button
            onMouseDown={handleMouseDownEvent}
            className={`${styles.miniChatInput__action} ${isGameChatUnavailable ? styles.miniChatInput__chatunavaialble : ''}`}
            disabled={!isGameChatUnavailable && !(value as string)?.trim()}
          >
            <Icon icon={Icons.Send} />
          </button>
        )}
      </div>
      <div className={styles.miniChatInput__supportingText}>
        {errorMessage ? <span className={styles.miniChatInput__errorMessage}>{errorMessage}</span> : null}
        {supportingText && !errorMessage ? supportingText : null}
      </div>
    </div>
  );
};
